export default {
    template: '<ul class="alert alert-danger error-summary" ng-if="$ctrl.errors && $ctrl.errors.length"><li ng-repeat="error in $ctrl.errors">{{error}}</li></ul>',
    bindings: {
        errors: '<'
    }
};


// WEBPACK FOOTER //
// ./app/components/error-summary.component.js